module.exports = __webpack_public_path__ + "static/img/btn-index.b48236b4.png";